import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Collapse from "@material-ui/core/Collapse";
import _ from "lodash";
import styled from "styled-components";
import { navigate } from "@reach/router";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { sidebar_options } from "./constants";
import COLORS from "../../../assets/Colors";

const drawerWidth = 273;
const collapsedDrawerWidth = 84;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    transition: "width 0.3s ease",
  },
  drawerCollapsed: {
    width: collapsedDrawerWidth,
    flexShrink: 0,
    transition: "width 0.3s ease",
  },
  drawerPaper: {
    width: drawerWidth,
    overflowX: "hidden",
    overflowY: "auto",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
    },
  },
  drawerPaperCollapsed: {
    width: collapsedDrawerWidth,
    transition: "width 0.3s ease",
    overflowX: "hidden",
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
    },
  },
  drawerContainer: {
    overflow: "auto",
    height: "100%",
    transition: "background-color 0.3s ease",
    "&::-webkit-scrollbar": { width: 3 },
    "&::-webkit-scrollbar-track": { background: "transparent" },
    "&::-webkit-scrollbar-thumb": {
      background: "rgba(255,255,255,0.0)",
      borderRadius: 4,
      transition: "background 0.3s",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      background: "rgba(255,255,255,0.22)",
    },
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(255,255,255,0.18) transparent",
  },
  iconContainer: {
    borderRadius: 8,
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 42,
    height: 42,
  },
  iconContainerCollapsedActive: {
    "& img": { filter: "brightness(0) invert(1)" },
  },
  iconContainerCollapsedInactive: {
    backgroundColor: "transparent",
    "& img": { filter: "none" },
  },
  inactiveListItem: {
    padding: "0px",
    paddingLeft: 47,
    height: 57,
    borderBottom: "solid 0.3px rgba(255, 255, 255, 0.12)",
    "&:hover": {
      "& span": { color: "#fff" },
    },
  },
  activeListItem: {
    padding: "0px",
    paddingLeft: 47,
    height: 57,
    borderBottom: "solid 0.3px rgba(255, 255, 255, 0.12)",
    // backgroundColor: "#00838c",
    "& span": { color: "#fff" },
  },
  nested: {
    margin: "10px 0 15px 0",
    marginLeft: "60px",
    width: "200px !important",
    height: "38px",
    borderRadius: "5px",
    transition: "300ms",
    boxSizing: "borderbox",
    "& span": {
      transition: "250ms",
      fontSize: "14px",
    },
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.05)",
      borderLeft: "3px solid #fff",
      "& span": { color: "#fff" },
    },
  },
  nestedCollapsed: {
    margin: "0 0 8px 0",
    marginLeft: "0px",
    width: "100% !important",
    height: "38px",
    borderRadius: "5px",
    justifyContent: "center",
    transition: "300ms",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.05)",
      "& span": { color: "#fff" },
    },
  },
  inactiveNested: { backgroundColor: "transparent" },
  activeNested: {
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    borderLeft: "3px solid #fff",
  },
  activeNestedCollapsed: {
    backgroundColor: "rgba(255, 255, 255, 0.05)",
  },
}));

export default function Sidebar({
  selectedItem,
  selectedSubItem,
  showDrawer,
  setShowDrawer,
}) {
  const classes = useStyles();
  const [expand, setExpand] = useState(true);
  const isCollapsed = showDrawer; // true = collapsed (icons only)

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    )
      return;
    setShowDrawer(false);
  };

  const handleMainClick = (data) => {
    if (data.hasOwnProperty("listItems")) {
      if (data.title === selectedItem) {
        setExpand(!expand);
      } else {
        navigate(data.path);
        setExpand(true);
      }
    } else {
      navigate(data.path);
    }
    setShowDrawer(false);
  };

  return (
    <Drawer
      open
      anchor="left"
      className={isCollapsed ? classes.drawerCollapsed : classes.drawer}
      onClose={toggleDrawer(false)}
      variant="permanent"
      classes={{
        paper: isCollapsed ? classes.drawerPaperCollapsed : classes.drawerPaper,
      }}
    >
      <Toolbar />
      <div
        className={classes.drawerContainer}
        style={{ backgroundColor: COLORS.BTN_GREEN }}
      >
        <List>
          {sidebar_options
            .filter((item) => item.showSidebar !== false)
            .map((data, index) => (
              <React.Fragment key={index}>
                <ListItem
                  className={
                    data.title === selectedItem
                      ? classes.activeListItem
                      : classes.inactiveListItem
                  }
                  button
                  onClick={() => handleMainClick(data)}
                  style={{
                    paddingLeft: isCollapsed ? 0 : 42,
                    justifyContent: isCollapsed ? "center" : "flex-start",
                  }}
                >
                  <ListItemIconContainer
                    className={`${classes.iconContainer} ${isCollapsed
                        ? data.title === selectedItem
                          ? classes.iconContainerCollapsedActive
                          : classes.iconContainerCollapsedInactive
                        : ""
                      }`}
                  >
                    <Icon
                      src={
                        data.title === selectedItem ? data.icon : data.inactive
                      }
                    />
                  </ListItemIconContainer>

                  {!isCollapsed && (
                    <ListItemText selected={data.title === selectedItem}>
                      <div className="row flex center-center">
                        <div className="flex flex-1">
                          {_.startCase(data.title)}
                        </div>
                        {data.hasOwnProperty("listItems") && (
                          <div className="mr30 flex">
                            {expand && data.title === selectedItem ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </div>
                        )}
                      </div>
                    </ListItemText>
                  )}
                </ListItem>

                {data.hasOwnProperty("listItems") && (
                  <Collapse
                    in={data.title === selectedItem && expand}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List
                      style={{
                        borderBottom: `solid 0.3px rgba(255, 255, 255, 0.12)`,
                        padding: isCollapsed ? "0 0 8px 0" : undefined,
                      }}
                      component="div"
                      disablePadding
                    >
                      {data.listItems.map((li, idx) =>
                        li.hide ? null : (
                          <ListItem
                            key={idx}
                            button
                            className={`${isCollapsed
                                ? classes.nestedCollapsed
                                : classes.nested
                              } ${li.title === selectedSubItem
                                ? isCollapsed
                                  ? classes.activeNestedCollapsed
                                  : classes.activeNested
                                : classes.inactiveNested
                              }`}
                            onClick={() => {
                              navigate(li.path);
                              setShowDrawer(false);
                            }}
                          >
                            <ListItemIconContainer
                              className={`${classes.iconContainer} ${isCollapsed
                                  ? li.title === selectedSubItem
                                    ? classes.iconContainerCollapsedActive
                                    : classes.iconContainerCollapsedInactive
                                  : ""
                                }`}
                            >
                              <Icon
                                src={
                                  li.title === selectedSubItem
                                    ? li.icon
                                    : li.inactive
                                }
                              />
                            </ListItemIconContainer>

                            {!isCollapsed && (
                              <ListItemText
                                selected={li.title === selectedSubItem}
                              >
                                {_.startCase(li.title)}
                              </ListItemText>
                            )}
                          </ListItem>
                        ),
                      )}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            ))}
        </List>
      </div>
    </Drawer>
  );
}

const ListItemText = styled.span`
  font-family: openSans-bold, sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  width: 100%;
`;

const Icon = styled.img`
  object-fit: contain;
  width: 18px;
  height: 18px;
`;

const ListItemIconContainer = styled.div``;
